import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function ViewAssignMenu() {
  const [roles, setRoles] = useState([]);
  const [menus, setMenus] = useState([]);
  //const [created_By, setCreatedBy] = useState("");

  const [roleId, setRoleId] = useState("");
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [isAssigned, setIsAssigned] = useState(false);

  useEffect(() => {
    loadRoles();
    loadMenus();
  }, []);

  const loadRoles = async () => {
    const res = await api.get("/Login/GetUser");
    setRoles(res.data);
  };

  //   const loadMenus = async () => {
  //     const res = await api.get("/Menu/GetMenu");
  //     setMenus(res.data);
  //   };
  const loadMenus = async () => {
    try {
      const res = await api.get("/Menu/GetMenu");
      setMenus(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadAssignedMenus = async (id) => {
    if (!id) {
      setSelectedMenus([]);
      setIsAssigned(false);
      return;
    }

    const res = await api.get(`/Menu/GetAssignedMenus/${id}`);

    setSelectedMenus(res.data);

    setIsAssigned(res.data.length > 0);
  };

  const handleRoleChange = (e) => {
    const id = e.target.value;
    setRoleId(id);
    loadAssignedMenus(id);
  };

  const handleMenu = (id) => {
    if (selectedMenus.includes(id)) {
      setSelectedMenus(selectedMenus.filter((x) => x !== id));
    } else {
      setSelectedMenus([...selectedMenus, id]);
    }
  };

  const save = async () => {
    if (roleId === "") {
      Swal.fire("Warning", "Select Role", "warning");
      return;
    }

    const data = {
      roleId,
      menuIds: selectedMenus,
      isActive: true,
      //created_By: Number(localStorage.getItem("roleId"))
    };

    try {
      if (isAssigned) {
        await api.post("/Menu/UpdateAssignMenu", data);

        Swal.fire("Success", "Menu Updated Successfully", "success");
      } else {
        await api.post("/Menu/AssignMenu", data);

        Swal.fire("Success", "Menu Assigned Successfully", "success");
      }
    } catch (error) {
      //   Swal.fire("Error", "Something went wrong", "error");
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error",
      );
      console.error(error);
    }
  };

  //const parents = menus.filter((x) => x.parentId == null);
  const parents = menus.filter(
    (x) => x.parentId == null || Number(x.parentId) === 0,
  );
  return (
    // <div className="container mt-4"></div>
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4>View Assign Menu</h4>
      </div>
      {/* <pre>{JSON.stringify(selectedMenus)}</pre> */}
      <div className="card-body">

        <div className="row">
<div className="col-md-4">
 <div className="mb-4">
          <label className="form-label">Select Role</label>

          <select
            className="form-select"
            value={roleId}
            onChange={handleRoleChange}
          >
            <option value="">Select Role</option>

            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.roleName} {role.userName}
              </option>
            ))}
          </select>
        </div>

</div>
<div className="col-md-8">


        <h5 className="mb-3">Menu Permission</h5>
  <hr />
        {parents.map((parent) => (
          <div key={parent.menuId} className="mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                checked={selectedMenus.includes(parent.menuId)}
                onChange={() => handleMenu(parent.menuId)}
              />

              <label className="form-check-label fw-bold">
                {parent.menuName}
              </label>
            </div>

            <div className="ms-4 mt-2">
              {menus
                .filter((x) => x.parentId === parent.menuId)
                .map((child) => (
                  <div className="form-check" key={child.menuId}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selectedMenus.includes(child.menuId)}
                      onChange={() => handleMenu(child.menuId)}
                    />

                    <label className="form-check-label">{child.menuName}</label>
                  </div>
                ))}
            </div>
          </div>
        ))}

        <div className="text-center mt-4">
          <button
            className={`btn ${isAssigned ? "btn-warning" : "btn-success"}`}
            onClick={save}
          >
            {isAssigned ? "Update Permission" : "Assign Permission"}
          </button>
        </div>

</div>

        </div>
       

      



      </div>
    </div>
  );
}

export default ViewAssignMenu;
